<template>
    <div class="info-content">
        <!-- Group 1: Id -->
        <div class="info-row">
            <span class="row-title">Id</span>
            <span class="row-value">{{ activeClient.id || "-" }}</span>
        </div>

        
        <!-- Group 2: Name, Chain name, Shop name -->
        <div class="info-row">
            <span class="row-title">{{ "Name" | t }}</span>
            <span class="row-value">{{ activeClient.name || "-" }}</span>
        </div>
        <div class="info-row">
            <span class="row-title">{{ "Chain name" | t }}</span>
            <span class="row-value">{{ activeClient.chain_name || "-" }}</span>
        </div>
        <div class="info-row">
            <span class="row-title">{{ "Shop name" | t }}</span>
            <span class="row-value">{{ activeClient.shop_name || "-" }}</span>
        </div>

        
        <!-- Group 3: Business type, Shop type -->
        <div class="info-row">
            <span class="row-title">{{ "Business type" | t }}</span>
            <span class="row-value">{{ activeClient.business_type || "-" }}</span>
        </div>
        <div class="info-row">
            <span class="row-title">{{ "Shop type" | t }}</span>
            <span class="row-value">{{ activeClient.shop_type || "-" }}</span>
        </div>

        
        <!-- Group 4: Comment, Address fields -->
        <div class="info-row">
            <span class="row-title">{{ "Comment" | t }}</span>
            <span class="row-value">{{ activeClient.comment || "-" }}</span>
        </div>
        <div class="info-row">
            <span class="row-title">{{ "Shop address" | t }}</span>
            <span class="row-value">{{ activeClient.shop_address || "-" }}</span>
        </div>
        <div class="info-row">
            <span class="row-title">{{ "Shop place" | t }}</span>
            <span class="row-value">{{ activeClient.shop_place || "-" }}</span>
        </div>
        <div class="info-row">
            <span class="row-title">{{ "Shop parish" | t }}</span>
            <span class="row-value">{{ activeClient.shop_parish || "-" }}</span>
        </div>
        <div class="info-row">
            <span class="row-title">{{ "Shop county" | t }}</span>
            <span class="row-value">{{ activeClient.shop_county || "-" }}</span>
        </div>
        <div class="info-row">
            <span class="row-title">{{ "Shop index" | t }}</span>
            <span class="row-value">{{ activeClient.shop_index || "-" }}</span>
        </div>
        <div class="info-row">
            <span class="row-title">{{ "Shop country" | t }}</span>
            <span class="row-value">{{ activeClient.shop_country || "-" }}</span>
        </div>
        <div class="info-row">
            <span class="row-title">{{ "Shop country code" | t }}</span>
            <span class="row-value">
                <country-flag
                    v-if="activeClient.shop_country_code"
                    :country="activeClient.shop_country_code"
                    size="small"
                    class="mr-1"
                />
                {{ activeClient.shop_country_code || "-" }}
            </span>
        </div>

        
        <!-- Group 5: Latitude, Longitude -->
        <div class="info-row">
            <span class="row-title">{{ "Latitude" | t }}</span>
            <span class="row-value">{{ activeClient.latitude || "-" }}</span>
        </div>
        <div class="info-row">
            <span class="row-title">{{ "Longitude" | t }}</span>
            <span class="row-value">{{ activeClient.longitude || "-" }}</span>
        </div>

        
        <!-- Group 6: Client country, Price list, Contractual relationship -->
        <div class="info-row">
            <span class="row-title">{{ "Client country" | t }}</span>
            <span class="row-value">
                <country-flag
                    v-if="activeClient.country_code"
                    :country="activeClient.country_code"
                    size="small"
                    class="mr-1"
                />
                {{ activeClient.country_estonian || activeClient.country_english || "-" }}
            </span>
        </div>
        <div class="info-row">
            <span class="row-title">{{ "Price list" | t }}</span>
            <span class="row-value">{{ activeClient.price_list || "-" }}</span>
        </div>
        <div class="info-row">
            <span class="row-title">{{ "Contractual relationship" | t }}</span>
            <span class="row-value">{{ activeClient.contractual_relationship || "-" }}</span>
        </div>

        
        <!-- Group 7: Tags -->
        <div class="info-row">
            <span class="row-title">{{ "Tags" | t }}</span>
            <span class="row-value">
                <template v-if="activeClient.tags && activeClient.tags.length > 0">
                    <v-chip
                        v-for="tag in activeClient.tags"
                        :key="tag.id"
                        x-small
                        class="mr-1"
                        @click="goToTag(tag.id)"
                    >
                        {{ tag.name }}
                    </v-chip>
                </template>
                <span v-else>-</span>
            </span>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import CountryFlag from "vue-country-flag";

export default {
    name: "client-info-tab",
    components: {
        CountryFlag
    },
    computed: {
        ...mapState("ClientStore", ["activeClient"])
    },
    methods: {
        goToTag(tagId) {
            this.$router.push({ name: "tag-view", params: { tagId: tagId } });
        }
    }
};
</script>

<style scoped>
.info-content {
    padding: 12px 20px;
}

.info-row {
    display: flex;
    align-items: center;
    min-height: 24px;
    line-height: 1.3;
}

.row-title {
    color: #888;
    width: 140px;
    flex-shrink: 0;
    font-size: 13px;
}

.row-value {
    font-size: 13px;
    color: #333;
}

</style>
